import { Observable } from "rxjs";
import { ColumnTypes } from "./data-grid.component";

export class Page {
  pageSize = 20; // The number of elements in a page
  pageNumber = 0; // The current page number
  availableRows = 0; // The total number of available rows
  availablePages = 0; // The total number of available pages
  totalRows = 0; // The total number of rows in the db
  rows: any[] = []; // The actual row data

  /** Returns the displayable row number for the row index on the current page */
  rowNumber(pageIndex: number) {
    return this.pageNumber * this.pageSize + pageIndex + 1;
  }
}

export interface GridDataProvider {
  page$: Observable<Page>;
  columnTypes$: Observable<ColumnTypes>;
  loadPage(esIndex: string, pageSize: number, pageNumber: number): void;
  loadColumnTypes(esIndex: string): void;
}
